/**
 * @author Akshay Kumar Singh
 * @file API Service
 * @flow
 */
import AlertModal from '../modals/AlertModal';
import Axios from "axios";
import { getData } from '../utils/storage.util';
import ROUTES from '../constants/routes';
import { spinnerService } from './spinner.service';
import { LABLES } from '../constants/data'

/**
 * @description This functional component fetch data from API's and send response back to the calling function in their callbacks
 */
export const CallApi = async (method = LABLES.GET, endpoint, customHeaders = {}, payload, role, returnMethod, history, uploadImage) => {
  let headers = {
    "Content-Type": "application/json",
    authorization: `Bearer ${getData('token')}`
  }
  let request;
  if (method === LABLES.GET) {
    request = {
      params: payload
    }
  } else {
    request = payload
  }
  await Axios({
    method: method,
    url: endpoint,
    data: request,
    headers: headers
  })
    .then(function (response) {
      spinnerService.hide(LABLES.Oval);
      if (response.data.responseCode === 200) {
        returnMethod(response.data)
      } if (response.data.responseCode === 401) {
        localStorage.removeItem('adminData')
        history.push(ROUTES.LANDING);
        AlertModal.showAlert(response.data.message);
      } else {
        AlertModal.showAlert(response.data.message);
      }
    })
    .catch(function (error) {
      spinnerService.hide(LABLES.Oval);
      AlertModal.showAlert(error.message);
    });
}
